export const LeadsPoolTestIDs = {
  qualificationContainer: 'leadsPool-qualificationContainer',
  qualificationTitle: 'leadsPool-qualificationTitle',
  qualificationIntro: 'leadsPool-qualificationIntro',
  requirementOne: 'leadsPool-requirementOne',
  requirementTwo: 'leadsPool-requirementTwo',
  footnote: 'leadsPool-footnote',
  radioYes: 'leadsPool-receiveLeadsYes',
  radioNo: 'leadsPool-receiveLeadsNo',
  warningContainer: 'leadsPool-warningContainer',
};
export default LeadsPoolTestIDs;
